<template>
	<CurvesPage class="curve" @onScale="drawLine">
		
		<!-- Название кривой (!Заполнить!) -->
		
		<template #curveName>Роза</template>
		
		<!-- модуль Характеристика кривой -->
		
		<template #curveFeature>
			
			<!-- Уравнение в полярных координатах -->
			<h5>Геометрическое место точек:</h5>
			<img src="@/assets/img/rosa_gmt.jpg" class="feature__gmt">
			<p class="feature__gmt">
				<strong>Полярная роза</strong>
				- известная математическая кривая, похожая на цветок с лепестками.
				Всякая точка <vue-mathjax :formula="viewExpression('M')" class="formula"></vue-mathjax>четырехлепестковой розы есть основание перпендикуляра
				<vue-mathjax :formula="viewExpression('|OM|')" class="formula"></vue-mathjax> к отрезку<vue-mathjax :formula="viewExpression('|AB|')" class="formula"></vue-mathjax>
				постоянной длины  <vue-mathjax :formula="viewExpression('2a')" class="formula"></vue-mathjax>, движущемуся так, что концы его все время находятся на координатных осях
		
			</p>
			
			
			<h5 class="mt-0">
				Полярное уравнение:
				<b-badge variant="light" class="curve__main-formula">
					<vue-mathjax
							:formula="equationInPolar"
							class="formula"
					></vue-mathjax>
				</b-badge>
			</h5>
			
			<!-- Уравнение в декартовых координатах -->
			
			<h5>Параметрическое уравнение:</h5>
			<p>
				<vue-mathjax
						:formula="equationParamInCartesian" class="formula"></vue-mathjax>
			</p>
			
			<!-- Область значений для параметра -->
			
			<h5 class="mt-0">Область значений <vue-mathjax :formula="parameterT" class="formula"></vue-mathjax>:</h5>
			
			<!--
				Параметры ползунка для выбора ОДЗ параметра (!Заполнить!)
				min - минимальная левая граница
				max - максимальная правая граница
				interval - шаг, с которым можно выбирать
				Для того, чтобы блокировать точки используй
				:dot-options="tDotOptions" для тега
				tDotOptions: [{            для data()
          disabled: false
        }, {
          disabled: true
        }]
			-->
			<vue-slider
					v-model="t"
					:min="0"
					:max="30"
					:interval="0.2"
					@dragging="drawLine"
			></vue-slider>
			<p>
				<vue-mathjax :formula="rangeODZ" class="formula"></vue-mathjax>
			</p>
			
			<!-- Значения коэффициентов (!Заполнить!) -->
			
			<h5>Зависимость от коэффициентов:</h5>
			
			<!-- Коэффициент a -->
			
			<label>
				<vue-mathjax :formula="coefficientA" class="formula"></vue-mathjax>:
			</label>
			
			<!--
				Параметры для выбора коэффициентов (!Заполнить!)
				min - минимальное значение коэффициента
				max - максимальное значение коэффициента
				step - шаг, с которым можно выбирать
				disabled - если нужно заблокировать выбор
			-->
			
			<b-form-spinbutton
					v-model="a"
					min="0"
					max="30"
					step="1"
					@input="drawLine"
					vertical
					class="curve__coef"
			></b-form-spinbutton>
			
			<!-- Коэффициент k -->
			
			<label>
				<vue-mathjax :formula="coefficientK" class="formula"></vue-mathjax>:
			</label>
			
			<!--
				Параметры для выбора коэффициентов (!Заполнить!)
				min - минимальное значение коэффициента
				max - максимальное значение коэффициента
				step - шаг, с которым можно выбирать
				disabled - если нужно заблокировать выбор
			-->
			
			<b-form-spinbutton
					v-model="k"
					min="0"
					max="12"
					step="0.1"
					@input="drawLine"
					vertical
					class="curve__coef"
			></b-form-spinbutton>
			
			<!-- Коэффициент k -->
			
			<label>
				<vue-mathjax :formula="coefficientB" class="formula"></vue-mathjax>:
			</label>
			
			<!--
				Параметры для выбора коэффициентов (!Заполнить!)
				min - минимальное значение коэффициента
				max - максимальное значение коэффициента
				step - шаг, с которым можно выбирать
				disabled - если нужно заблокировать выбор
			-->
			
			<b-form-spinbutton
					v-model="b"
					min="0"
					max="12"
					step="0.2"
					@input="drawLine"
					vertical
					class="curve__coef"
			></b-form-spinbutton>
			
			<p v-if="(k == 1) && (b !== 0) && (a !== 0)">Этот частный случай называют <i>Улиткой Паскаля</i>. <br><a href="/limacon">Изучить подробнее...</a></p>
		
		</template>
		
		<!-- модуль Информация о кривой -->
		
		<!-- Изображение для модуля информации -->
		
		<template #curvePhoto>
			<div>
			<div class="info__picture">
			<img src="@/assets/img/Leibniz_rose.jpg" width="100" alt="Лейбниц">
			</div>
			<div class="info__picture">
			<img src="@/assets/img/Guidograndi_rose.jpg" width="100" alt="Гвидо Гранди">
			</div>
			</div>
		</template>
		
		<!-- Контент -->
		
		<template #curveInfo>
			<h5>История:</h5>
				<p>
					Впервые об этой кривой упоминает флорентийский монах <i><b>Гвидо Гранди</b></i> в двух письмах <i><b>Лейбницу</b></i> в декабре 1713 года\ и называет её «розовидной»(«rhodonea», от др.-греч. ῥόδον — «роза»).
					Через десять лет он опубликовал статью о ней в «Философских трудах Королевского общества», где рассмотрел разновидности этой кривой с различным количеством лепестков и также называл их «розовидными».
					Ещё через пять лет <i><b>Гвидо Гранди</b></i> развил теорию розовидных кривых в отдельном труде, где наряду с этим рассмотрел похожие на них пространственные кривые, лежащие на сфере, которые он назвал «клелиями» в честь княгини <i><b>Клелии Борромео</b></i> .
				</p>
			<h5>Интересные факты:</h5>
			<ul>
				<li> В силу периодичности тригонометрических функций роза состоит из одинаковых лепестков, симметричных относительно наибольших радиусов, каждый из которых равен 1.</li>
			</ul>
		</template>
		
		<!-- модуль Задачи -->
		
		<template #curveTasks>
			<h5 class="mt-0">Примеры задач:</h5>
		</template>
	
	</CurvesPage>
</template>

<script>
	import CurvesPage, { CurvesInterface } from '@/views/templates/CurvesPage';
	
	export default {
		name: 'Roses',
		mixins: [CurvesInterface],
		data () {
			return {
				/* Коэффициенты уравнения (!Заполнить!) */
				a: 0,
				b: 0,
				k: 0,
				/* ОДЗ параметра (!Заполнить!) */
				t: [2, 3]
			}
		},
		computed: {
			/* Функции для представления в latex (!Заполнить!)
			 * equationInPolar - Уравнение в полярных координатах
			 * equationInCartesian - Аналитическое уравнение
			 * equationParamInCartesian - Параметрическое уравнение
			  * */
			equationInPolar: () => {
				return '$$ r = a \\cos k \\theta + b $$';
			},
			equationParamInCartesian: () => {
				return '$$ \\begin{cases} x = (a \\cos (k t) + b) \\cos (t) \\\\ y = (a \\cos (k t) + b)  \\sin (t) \\end{cases} $$';
			},
			/**
			 * ОДЗ (!Заполнить!)
			 * Свойства возвращают реальные границы для параметра t
			 * (в том случае, если границы, выбираемые ползунком нужно преобразовать)
			 * Пример: значения определённые ползунком [0, 2], но реальные границы 0 * pi < t < 2 * pi
			 * minTheta - левая граница
			 * maxTheta - правая граница
			 * rangeODZ - представление
			 * */
			rangeODZ: (context) => {
				return '$$ ' + context.t[0] +  ' \\pi < t <' + context.t[1] + ' \\pi $$';
			},
			maxTheta: ({ t }) => {
				return t[1] * Math.PI;
			},
			minTheta: ({ t }) => {
				return t[0] * Math.PI;
			}
		},
		methods: {
			/**
			 * (!Заполнить!)
			 * Возвращает значение x при заданном параметре
			 * @param {number} t
			 * @return {number}
			 */
			X (t) {
				return 160 + ((this.a * Math.cos(this.k * t) + this.b) * Math.cos(t)) * this.$store.state.step;
			},
			/**
			 * (!Заполнить!)
			 * Возвращает значение y при заданном параметре
			 * @param {number} t
			 * @return {number}
			 */
			Y (t) {
				return 160 + ((this.a * Math.cos(this.k * t) + this.b) * Math.sin(t)) * this.$store.state.step;
			}
		},
		components: {
			CurvesPage
		}
	}
</script>

<style scoped lang="scss">

</style>
